import { render, staticRenderFns } from "./BannerActivateRewards.vue?vue&type=template&id=fee43302&scoped=true&"
import script from "./BannerActivateRewards.vue?vue&type=script&lang=ts&"
export * from "./BannerActivateRewards.vue?vue&type=script&lang=ts&"
import style0 from "./BannerActivateRewards.vue?vue&type=style&index=0&id=fee43302&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee43302",
  null
  
)

export default component.exports